import Navbar from "../Navbar/Navbar";

export default function NotFound() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <h1 style={{ textAlign: "center" }}>Oops!! 404 Not Found</h1>
    </div>
  );
}
